// extracted by mini-css-extract-plugin
export var closeButton = "_km-1";
export var closeX = "_km-3";
export var container = "_km-0";
export var image = "_km-2";